// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3ZgYc","footer":"ModalCreateQualiphyProcedure_footer__1FK6P","additionData":"ModalCreateQualiphyProcedure_additionData__2K_pF"};